export default "/images/trash.png?ebe0f1e8a7a0ce414f9bb7602ebc2033";